<template>
  <transition name="fade">
    <div v-if="show" class="flex justify-center items-center fixed inset-0 py-16 px-8 bg-primary-nav z-50">
      <div class="tooltip bg-white text-primary rounded-lg max-w-sm p-8">
        <div class="flex justify-between">
          <h3>{{ tooltip.title }}</h3>
          <button aria-label="Sluit venster" @click="close">
            <font-awesome-icon
              :icon="['far', 'times']"
              aria-hidden="true"
              size="2x"
              class="text-primary"
            />
          </button>
        </div>

        <article class="overflow-y-scroll">
          {{ tooltip.text }}
          <slot/>
        </article>
      </div>
    </div>
  </transition>
</template>

<script>
import data from '~/static/tooltips.json';

export default {
  props: {
    step: {
      type: Number,
      required: true,
    },

    show: {
      type: Boolean,
      required: true,
    },
  },

  computed: {
    tooltip() {
      return data.tooltips.find(tip => tip.step === this.step);
    },
  },

  watch: {
    show() {
      this.show ? this.lock() : this.unlock();
    },
  },

  methods: {
    lock() {
      document.body.classList.add('overflow-hidden');
    },

    unlock() {
      document.body.classList.remove('overflow-hidden');
    },

    close() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped>
.tooltip {
  height: fit-content;
}

.tooltip article {
  max-height: 60vh;
}
</style>
